import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8552c47a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8552c47a&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=8552c47a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8552c47a",
  null
  
)

export default component.exports